import CloseIcon from "@mui/icons-material/Close";
import PodcastsOutlinedIcon from "@mui/icons-material/PodcastsOutlined";
import { Alert, IconButton, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import { FormattedMessage, useIntl } from "react-intl";
import type { FC } from "react";

export const LIVE_ENVIRONMENT_ANIMATION_DURATION = 600;

const bounceIn = keyframes`
	from {
		opacity: 0;
		transform: translateX(-50%) translateY(100%);
	}

	to {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}
`;

const bounceOut = keyframes`
	from {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}

	to {
		opacity: 0;
		transform: translateX(-50%) translateY(100%);
	}
`;

export interface LiveEnvironmentWrapperTemplateProps {
	readonly isAnimateIn: boolean;
	readonly onClose: () => void;
}

export const LiveEnvironmentWrapperTemplate: FC<LiveEnvironmentWrapperTemplateProps> = ({ isAnimateIn, onClose }) => {
	const intl = useIntl();

	return (
		<Alert
			severity="success"
			variant="filled"
			icon={<PodcastsOutlinedIcon />}
			action={
				<IconButton
					aria-label={intl.formatMessage({ id: "Close", defaultMessage: "Close" })}
					color="inherit"
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			}
			sx={{
				position: "fixed",
				minWidth: "80%",
				bottom: "4rem",
				left: "50%",
				transform: "translateX(-50%)",
				alignItems: "center",
				"& .MuiAlert-message": {
					display: "flex",
					alignItems: "center",
				},
				animation: `${isAnimateIn ? bounceIn : bounceOut} ${LIVE_ENVIRONMENT_ANIMATION_DURATION}ms cubic-bezier(0.16, 1, 0.3, 1)`,
			}}
			data-testid="live-environment-wrapper__alert"
		>
			<Typography>
				<FormattedMessage
					id="This is a live customer environment. Changes may impact production."
					defaultMessage="This is a live customer environment. Changes may impact production."
				/>
			</Typography>
		</Alert>
	);
};
